import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export type BlogPostCardData = {
  id: string;
  title: string;
  description: string;
  image: string;
  tag: string;
  date: string;
  readTime: string;
  slug: string;
  author?: string;
};

type BlogPostCardProps = {
  post: BlogPostCardData;
};

const BlogPostCard: React.FC<BlogPostCardProps> = ({ post }) => {
  return (
    <motion.article
      whileHover={{ y: -4 }}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4 }}
      className="group cursor-pointer"
    >
      <Link to={`/blog/${post.slug}`} className="block h-full">
        <div className="relative overflow-hidden rounded-[16px] aspect-[4/3] bg-gray-100">
          <motion.img
            src={post.image}
            alt={post.title}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        </div>

        <div className="mt-4 space-y-2 px-0.5">
          <div className="flex items-center justify-between text-[10px] font-normal text-[#919191] font-description">
            <div className="flex items-center gap-1.5">
              <span className="text-[#212121] font-title text-[10px]">{post.tag}</span>
              <span className="w-1 h-1 rounded-full bg-gray-300 mx-0.5" />
              <span>{post.date}</span>
            </div>
            <span>By {post.author || 'Agency'}</span>
          </div>

          <h5
            className="text-[16px] md:text-[18px] leading-[1.25] transition-colors font-title font-medium text-[#212121] group-hover:text-primary"
          >
            {post.title}
          </h5>

          <p
            className="line-clamp-2 text-[12px] md:text-[13px] leading-[1.5] text-[#919191] font-description font-light"
          >
            {post.description}
          </p>

          <div className="pt-1">
            <span
              className="inline-flex items-center gap-1 text-[12px] font-medium group-hover:gap-1.5 transition-all text-[#212121] group-hover:text-primary font-title"
            >
              Read the article
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="19" x2="19" y2="5"></line><polyline points="5 5 19 5 19 19"></polyline></svg>
            </span>
          </div>
        </div>
      </Link>
    </motion.article>
  );
};

export default BlogPostCard;
